import { Form, FormItemProps, InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib';

interface InputNumberFormProps {
  formProps?: FormItemProps;
  inputNumberProps?: InputNumberProps;
}

export const InputNumberForm = ({
  formProps,
  inputNumberProps,
}: InputNumberFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    <InputNumber
      className='w-100'
      {...inputNumberProps}
      placeholder={inputNumberProps?.placeholder ?? ''}
    />
  </Form.Item>
);
